import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
    Container,
    Row,
    Col,
    Button,
    Card,
    CardHeader,
    CardBody,
    Table,
    Input,
    Label,
    FormGroup,
    Modal,
    ModalHeader,
    ModalBody,
    Pagination,
    PaginationItem,
    PaginationLink,
    Spinner,
    ButtonGroup,
} from "reactstrap";
import dayjs from 'dayjs';
import { apiURL1 } from '../../config';
import { toast } from 'react-toastify';

import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

const baseURL = apiURL1;

function SalaryManagement() {
    const token = localStorage.getItem("token");

    const currentMonth = dayjs().month() + 1;
    const currentYear = dayjs().year();



    const [month, setMonth] = useState(currentMonth);
    const [year, setYear] = useState(currentYear);
    const [salaries, setSalaries] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [selectedSalary, setSelectedSalary] = useState(null);
    const [viewModalOpen, setViewModalOpen] = useState(false);
    const [calculateModalOpen, setCalculateModalOpen] = useState(false);
    const [calculateMonth, setCalculateMonth] = useState(currentMonth);
    const [calculateYear, setCalculateYear] = useState(currentYear);
    const [totalCount, setTotalCount] = useState(0);
    const [madrasaInfo, setMadrasaInfo] = useState({});

    useEffect(() => {
        fetchSalaries();
        fetchMadrasaInfo();
    }, [month, year, page]);


    const printSalaryDetails = (salary) => {
        const printContent = `
            <html>
            <head>
                <title>Salary Details</title>
                <style>
                    body { font-family: Arial, sans-serif; margin: 20px; }
                    .header { text-align: center; margin-bottom: 20px; }
                    .school-name { font-size: 24px; font-weight: bold; }
                    .school-info { font-size: 14px; }
                    .salary-title { font-size: 20px; margin-bottom: 10px; }
                    .salary-details { margin-top: 20px; }
                    .footer { text-align: center; margin-top: 20px; font-size: 12px; }
                    table { width: 100%; border-collapse: collapse; margin-top: 15px; }
                    th, td { padding: 8px; text-align: left; border-bottom: 1px solid #ddd; }
                    th { background-color: #f2f2f2; }
                    div { margin-bottom: 5px; } /* Add margin to create spacing */
                </style>
            </head>
            <body>
                <div class="header">
                    <img src="https://res.cloudinary.com/djg7v9dna/image/upload/v1739198257/Logo/kgamz0yjfr9uy8dsbnur.webp" alt="Madrasa Logo" width="100"/>
                    <div class="school-name">${madrasaInfo.schoolName || 'Madrasa Name'}</div>
                    <div class="school-info">
                        ${madrasaInfo.schoolAddress || 'Madrasa Address'}<br/>
                        Tel: ${madrasaInfo.schoolPhoneNumber || 'Phone'} | Email: ${madrasaInfo.schoolEmail || 'Email'}
                    </div>
                </div>
                <div class="salary-title">Salary Details</div>
                <div class="salary-details">
                    <div><strong>Staff Name:</strong> ${salary.teacherId?.name}</div>
                    <div><strong>Month:</strong> ${dayjs().month((salary.month || 1) - 1).format('MMMM')}</div>
                    <div><strong>Year:</strong> ${salary.year}</div>
                    <div><strong>Final Salary:</strong> ${salary.finalSalary?.toFixed(2)}</div>
                    <div><strong>Basic Salary:</strong> ${salary.basicSalary?.toFixed(2)}</div>
                    <div><strong>Total Allowances:</strong> ${salary.totalAllowances?.toFixed(2)}</div>
                    <div><strong>Total Deductions:</strong> ${salary.totalDeductions?.toFixed(2)}</div>
                    <div><strong>Total Bonuses:</strong> ${salary.totalBonuses?.toFixed(2)}</div>
                    
                    ${salary.allowances && salary.allowances.length > 0 ? `
                        <div><strong>Allowances:</strong></div>
                        <table>
                            <thead><tr><th>Name</th><th>Value</th></tr></thead>
                            <tbody>
                                ${salary.allowances.map(allowance => `<tr><td>${allowance.name}</td><td>${allowance.value?.toFixed(2)}</td></tr>`).join('')}
                            </tbody>
                        </table>
                    ` : ''}
                    
                    ${salary.deductions && salary.deductions.length > 0 ? `
                        <div><strong>Deductions:</strong></div>
                        <table>
                            <thead><tr><th>Name</th><th>Value</th></tr></thead>
                            <tbody>
                                ${salary.deductions.map(deduction => `<tr><td>${deduction.name}</td><td>${deduction.value?.toFixed(2)}</td></tr>`).join('')}
                            </tbody>
                        </table>
                    ` : ''}
                    
                    ${salary.bonuses && salary.bonuses.length > 0 ? `
                        <div><strong>Bonuses:</strong></div>
                        <table>
                            <thead><tr><th>Name</th><th>Value</th></tr></thead>
                            <tbody>
                                ${salary.bonuses.map(bonus => `<tr><td>${bonus.name}</td><td>${bonus.value?.toFixed(2)}</td></tr>`).join('')}
                            </tbody>
                        </table>
                    ` : ''}
                    
                    <div><strong>Total Overtime Hours:</strong> ${salary.totalOvertime?.hours?.toFixed(2) || '0.00'}</div>
                    <div><strong>Total Overtime Price Per Hour:</strong> ${salary.totalOvertime?.pricePerHour?.toFixed(2) || '0.00'}</div>
                    <div><strong>Total Overtime Amount:</strong> ${salary.totalOvertime?.totalOvertimeAmount?.toFixed(2) || '0.00'}</div>
                    
                    <div><strong>Full Days Count:</strong> ${salary.attendanceDetails?.fullDays?.count?.toFixed(2) || '0.00'}</div>
                    <div><strong>Full Days Salary Per Day:</strong> ${salary.attendanceDetails?.fullDays?.salaryPerDay?.toFixed(2) || '0.00'}</div>
                    <div><strong>Full Days Total Salary:</strong> ${salary.attendanceDetails?.fullDays?.totalFullDaySalary?.toFixed(2) || '0.00'}</div>
                    
                    <div><strong>Half Days Count:</strong> ${salary.attendanceDetails?.halfDays?.count?.toFixed(2) || '0.00'}</div>
                    <div><strong>Half Days Salary Per Half Day:</strong> ${salary.attendanceDetails?.halfDays?.salaryPerHalfDay?.toFixed(2) || '0.00'}</div>
                    <div><strong>Half Days Total Salary:</strong> ${salary.attendanceDetails?.halfDays?.totalHalfDaySalary?.toFixed(2) || '0.00'}</div>
                    
                    <div><strong>Absences Count:</strong> ${salary.attendanceDetails?.absences?.count?.toFixed(2) || '0.00'}</div>
                    <div><strong>Absences Deduction Per Absence:</strong> ${salary.attendanceDetails?.absences?.deductionPerAbsence?.toFixed(2) || '0.00'}</div>
                    <div><strong>Absences Total Deduction:</strong> ${salary.attendanceDetails?.absences?.totalAbsenceDeduction?.toFixed(2) || '0.00'}</div>
                    
                    ${salary.attendanceDetails?.totalDays !== undefined ? `<div><strong>Total Days:</strong> ${salary.attendanceDetails?.totalDays?.toFixed(2)}</div>` : ''}
                    ${salary.attendanceDetails?.totalHours !== undefined ? `<div><strong>Total Hours:</strong> ${salary.attendanceDetails?.totalHours?.toFixed(2)}</div>` : ''}
                </div>
                <div class="footer">Generated on: ${new Date().toLocaleDateString()}</div>
            </body>
            </html>
        `;

        const printWindow = window.open('', '', 'width=800,height=600');
        printWindow.document.write(printContent);
        printWindow.document.close();
        printWindow.print();
    };

    const fetchMadrasaInfo = async () => {
        try {
            const response = await axios.get(`${baseURL}/superadmin/school-settings`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
            const data = response.data;
            if (data && data.length > 0) {
                setMadrasaInfo(data[0]);
            }
        } catch (error) {
            console.error('Error fetching madrasa info:', error);
        }
    };

    const fetchSalaries = async () => {
        setLoading(true);
        try {
            const response = await axios.get(
                `${baseURL}/superadmin/salaries?page=${page}&month=${month}&year=${year}`
                , {
                    headers: {
                        'Authorization': `Bearer ${token}`, // Include the token in the headers
                    }
                }
            );
            if (response.data && response.data.salaries) {
                setSalaries(response.data.salaries);
                setTotalPages(response.data.totalPages);
                setTotalCount(response.data.totalCount);
            } else {
                setSalaries([]);
                setTotalPages(0);
                setTotalCount(0);
            }
        } catch (error) {
            console.error('Error fetching salaries:', error);
            toast.error('Error fetching salaries');
            setSalaries([]);
            setTotalPages(0);
            setTotalCount(0);
        } finally {
            setLoading(false);
        }
    };

    const calculateSalary = async () => {
        setLoading(true);
        try {
            await axios.get(
                `${baseURL}/superadmin/salary/calculate?month=${calculateMonth}&year=${calculateYear}`
                , {
                    headers: {
                        'Authorization': `Bearer ${token}`, // Include the token in the headers
                    }
                }
            );
            toast.success('Salaries calculated successfully!');
            fetchSalaries(); // Refresh salary data after calculation
        } catch (error) {
            console.error('Error calculating salary:', error);
            toast.error('Error calculating salary');
        } finally {
            setLoading(false);
            setCalculateModalOpen(false); // Close the modal after calculation
        }
    };

    const handleMonthChange = (e) => {
        setMonth(parseInt(e.target.value));
        setPage(1); // Reset page to 1 when month changes
    };

    const handleYearChange = (e) => {
        setYear(parseInt(e.target.value));
        setPage(1); // Reset page to 1 when year changes
    };

    const handleView = (salary) => {
        setSelectedSalary(salary);
        setViewModalOpen(true);
    };

    const handleCloseViewModal = () => {
        setViewModalOpen(false);
        setSelectedSalary(null);
    };

    const renderPagination = () => {
        const paginationItems = [];
        for (let i = 1; i <= totalPages; i++) {
            paginationItems.push(
                <PaginationItem key={i} active={i === page}>
                    <PaginationLink onClick={() => setPage(i)}>{i}</PaginationLink>
                </PaginationItem>
            );
        }

        return (
            <Pagination style={{ justifyContent: 'center' }}>
                <PaginationItem disabled={page === 1}>
                    <PaginationLink previous onClick={() => setPage(page - 1)} />
                </PaginationItem>
                {paginationItems}
                <PaginationItem disabled={page === totalPages}>
                    <PaginationLink next onClick={() => setPage(page + 1)} />
                </PaginationItem>
            </Pagination>
        );
    };

    const openCalculateModal = () => {
        setCalculateModalOpen(true);
    };

    const closeCalculateModal = () => {
        setCalculateModalOpen(false);
    };

    const handleCalculateMonthChange = (e) => {
        setCalculateMonth(parseInt(e.target.value));
    };

    const handleCalculateYearChange = (e) => {
        setCalculateYear(parseInt(e.target.value));
    };

    const generateSalaryReport = async () => {
        setLoading(true);
        try {
            const response = await axios.get(
                `${baseURL}/superadmin/salaries?month=${month}&year=${year}`
                , {
                    headers: {
                        'Authorization': `Bearer ${token}`, // Include the token in the headers
                    }
                }
            );

            if (response.data && response.data.salaries) {
                const allSalaries = response.data.salaries;
                const pdf = new jsPDF('p', 'mm', 'a4');
                const pageWidth = pdf.internal.pageSize.getWidth();
                const margin = 10;

                // School Logo and Information (Header)
                const img = new Image();
                img.src = "https://res.cloudinary.com/djg7v9dna/image/upload/v1742946371/mi0wavjsehps20kdzaet.png";

                pdf.addImage(img, 'PNG', 15, 15, 30, 30);

                pdf.setFontSize(16);
                pdf.setFont('helvetica', 'bold');
                pdf.text(madrasaInfo.schoolName || 'Madrasa Name', 50, 22);
                pdf.setFontSize(10);
                pdf.setFont('helvetica', 'normal');
                pdf.text(madrasaInfo.schoolAddress || 'Madrasa Address', 50, 28);
                pdf.text(`Tel: ${madrasaInfo.schoolPhoneNumber || 'Phone'} | Email: ${madrasaInfo.schoolEmail || 'Email'}`, 50, 34);

                allSalaries.forEach((salary, index) => {
                    let yPosition = 50;

                    // Title
                    pdf.setFontSize(16);
                    pdf.setFont('helvetica', 'bold');
                    pdf.setTextColor(79, 129, 189); // Title color
                    pdf.text(`Salary Slip for ${salary.teacherId?.name}`, margin, yPosition);
                    yPosition += 10;

                    // Employee Details
                    pdf.setFontSize(12);
                    pdf.setFont('helvetica', 'normal');
                    pdf.setTextColor(0); // Reset text color
                    pdf.text(`Teacher ID: ${salary.teacherId?._id || 'N/A'}`, margin, yPosition);
                    yPosition += 7;
                    pdf.text(`Email: ${salary.teacherId?.email || 'N/A'}`, margin, yPosition);
                    yPosition += 7;
                    pdf.text(`Month: ${dayjs().month((salary.month || 1) - 1).format('MMMM')}`, margin, yPosition);
                    yPosition += 7;
                    pdf.text(`Year: ${salary.year}`, margin, yPosition);
                    yPosition += 10;

                    // Function to add tables with styling
                    const addStyledTable = (title, items, yPos) => {
                        pdf.setFontSize(12);
                        pdf.setFont('helvetica', 'bold');
                        pdf.setTextColor(79, 129, 189); // Table title color
                        pdf.text(title, margin, yPos);

                        yPos += 8;
                        pdf.setTextColor(0); // Reset text color
                        if (items && items.length > 0) {
                            const tableData = items.map(item => [item.name, item.value?.toFixed(2)]);
                            pdf.autoTable({
                                head: [['Name', 'Value']],
                                body: tableData,
                                startY: yPos,
                                margin: { left: margin },
                                styles: {
                                    fontSize: 10,
                                    textColor: 0,
                                    cellPadding: 3,
                                    overflow: 'linebreak',
                                    lineWidth: 0.3,
                                    lineColor: [220, 220, 220],
                                },
                                headStyles: {
                                    fillColor: [230, 230, 230],
                                    textColor: 0,
                                    fontStyle: 'bold',
                                    lineWidth: 0.3,
                                    lineColor: [220, 220, 220],
                                },
                                alternateRowStyles: {
                                    fillColor: [245, 245, 245],
                                },
                            });
                            return pdf.autoTable.previous.finalY + 10;
                        } else {
                            pdf.setFontSize(11);
                            pdf.setFont('helvetica', 'normal');
                            pdf.text('No', margin, yPos);
                            return yPos + 10;
                        }
                    };

                    // Add styled tables for allowances, deductions, and bonuses
                    yPosition = addStyledTable('Allowances', salary.allowances, yPosition);
                    yPosition = addStyledTable('Deductions', salary.deductions, yPosition);
                    yPosition = addStyledTable('Bonuses', salary.bonuses, yPosition);

                    // Salary Summary
                    pdf.setFontSize(14);
                    pdf.setFont('helvetica', 'bold');
                    pdf.setTextColor(79, 129, 189); // Summary title color
                    pdf.text('Salary Summary', margin, yPosition);
                    yPosition += 10;

                    pdf.setFontSize(12);
                    pdf.setFont('helvetica', 'normal');
                    pdf.setTextColor(0); // Reset text color
                    pdf.text(`Basic Salary: ${salary.basicSalary?.toFixed(2)}`, margin, yPosition);
                    yPosition += 7;
                    pdf.text(`Total Allowances: ${salary.totalAllowances?.toFixed(2)}`, margin, yPosition);
                    yPosition += 7;
                    pdf.text(`Total Deductions: ${salary.totalDeductions?.toFixed(2)}`, margin, yPosition);
                    yPosition += 7;
                    pdf.text(`Total Bonuses: ${salary.totalBonuses?.toFixed(2)}`, margin, yPosition);
                    yPosition += 7;
                    pdf.setFontSize(13);
                    pdf.setFont('helvetica', 'bold');
                    pdf.text(`Final Salary: ${salary.finalSalary?.toFixed(2)}`, margin, yPosition);

                    // Footer
                    const totalPages = pdf.getNumberOfPages();
                    for (let i = 1; i <= totalPages; i++) {
                        pdf.setPage(i);
                        pdf.setFontSize(8);
                        pdf.setTextColor(0, 0, 0);
                        pdf.text(`Generated on: ${new Date().toLocaleDateString()} | ${madrasaInfo.schoolName || 'Madrasa Name'}`,
                            pageWidth - 40, pdf.internal.pageSize.getHeight() - 10);
                    }

                    // Add a new page for the next salary if it's not the last one
                    if (index < allSalaries.length - 1) {
                        pdf.addPage();
                    }
                });

                pdf.save(`salary-report-${month}-${year}.pdf`);
            } else {
                toast.error('No salary records found for the selected month and year.');
            }
        } catch (error) {
            console.error('Error generating salary report:', error);
            toast.error('Error generating salary report');
        } finally {
            setLoading(false);
        }
    };

    const downloadIndividualSalarySlip = (salary) => {
        const pdf = new jsPDF('p', 'mm', 'a4');
        const pageWidth = pdf.internal.pageSize.getWidth();
        const margin = 10;
        let yPosition = margin;

        // School Logo and Information (Header)
        const img = new Image();
        img.src = "https://res.cloudinary.com/djg7v9dna/image/upload/v1742946371/mi0wavjsehps20kdzaet.png";

        pdf.addImage(img, 'PNG', 15, 15, 30, 30);

        pdf.setFontSize(16);
        pdf.setFont('helvetica', 'bold');
        pdf.text(madrasaInfo.schoolName || 'Madrasa Name', 50, 22);
        pdf.setFontSize(10);
        pdf.setFont('helvetica', 'normal');
        pdf.text(madrasaInfo.schoolAddress || 'Madrasa Address', 50, 28);
        pdf.text(`Tel: ${madrasaInfo.schoolPhoneNumber || 'Phone'} | Email: ${madrasaInfo.schoolEmail || 'Email'}`, 50, 34);

        yPosition = 50;

        // Title
        pdf.setFontSize(16);
        pdf.setFont('helvetica', 'bold');
        pdf.setTextColor(79, 129, 189);
        pdf.text(`Salary Slip for ${salary.teacherId?.name}`, margin, yPosition);
        yPosition += 10;

        // Employee Details
        pdf.setFontSize(12);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(0);
        pdf.text(`Teacher ID: ${salary.teacherId?._id || 'N/A'}`, margin, yPosition);
        yPosition += 7;
        pdf.text(`Email: ${salary.teacherId?.email || 'N/A'}`, margin, yPosition);
        yPosition += 7;
        pdf.text(`Month: ${dayjs().month((salary.month || 1) - 1).format('MMMM')}`, margin, yPosition);
        yPosition += 7;
        pdf.text(`Year: ${salary.year}`, margin, yPosition);
        yPosition += 10;

        // Function to add styled tables
        const addStyledTable = (title, items, yPos) => {
            pdf.setFontSize(12);
            pdf.setFont('helvetica', 'bold');
            pdf.setTextColor(79, 129, 189);
            pdf.text(title, margin, yPos);

            yPos += 8;
            pdf.setTextColor(0);
            if (items && items.length > 0) {
                const tableData = items.map(item => [item.name, item.value?.toFixed(2)]);
                pdf.autoTable({
                    head: [['Name', 'Value']],
                    body: tableData,
                    startY: yPos,
                    margin: { left: margin },
                    styles: {
                        fontSize: 10,
                        textColor: 0,
                        cellPadding: 3,
                        overflow: 'linebreak',
                        lineWidth: 0.3,
                        lineColor: [220, 220, 220],
                    },
                    headStyles: {
                        fillColor: [230, 230, 230],
                        textColor: 0,
                        fontStyle: 'bold',
                        lineWidth: 0.3,
                        lineColor: [220, 220, 220],
                    },
                    alternateRowStyles: {
                        fillColor: [245, 245, 245],
                    },
                });
                return pdf.autoTable.previous.finalY + 10;
            } else {
                pdf.setFontSize(11);
                pdf.setFont('helvetica', 'normal');
                pdf.text('No data available', margin, yPos);
                return yPos + 10;
            }
        };

        // Add styled tables for allowances, deductions, and bonuses
        yPosition = addStyledTable('Allowances', salary.allowances, yPosition);
        yPosition = addStyledTable('Deductions', salary.deductions, yPosition);
        yPosition = addStyledTable('Bonuses', salary.bonuses, yPosition);

        // Salary Summary
        pdf.setFontSize(14);
        pdf.setFont('helvetica', 'bold');
        pdf.setTextColor(79, 129, 189);
        pdf.text('Salary Summary', margin, yPosition);
        yPosition += 10;

        pdf.setFontSize(12);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(0);
        pdf.text(`Basic Salary: ${salary.basicSalary?.toFixed(2)}`, margin, yPosition);
        yPosition += 7;
        pdf.text(`Total Allowances: ${salary.totalAllowances?.toFixed(2)}`, margin, yPosition);
        yPosition += 7;
        pdf.text(`Total Deductions: ${salary.totalDeductions?.toFixed(2)}`, margin, yPosition);
        yPosition += 7;
        pdf.text(`Total Bonuses: ${salary.totalBonuses?.toFixed(2)}`, margin, yPosition);
        yPosition += 7;
        pdf.setFontSize(13);
        pdf.setFont('helvetica', 'bold');
        pdf.text(`Final Salary: ${salary.finalSalary?.toFixed(2)}`, margin, yPosition);

        // Footer
        const totalPages = pdf.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(8);
            pdf.setTextColor(0, 0, 0);
            pdf.text(`Generated on: ${new Date().toLocaleDateString()} | ${madrasaInfo.schoolName || 'Madrasa Name'}`,
                pageWidth - 40, pdf.internal.pageSize.getHeight() - 10);
        }

        pdf.save(`salary-slip-${salary.teacherId?.name}-${salary.month}-${salary.year}.pdf`);
    };

    return (
        <Container>
            <Row className="mb-3">
                <Col md={3}>
                    <FormGroup>
                        <Label>Month</Label>
                        <Input
                            type="select"
                            value={month}
                            onChange={handleMonthChange}
                        >
                            {Array.from({ length: 12 }, (_, i) => i + 1).map((m) => (
                                <option key={m} value={m}>
                                    {dayjs().month(m - 1).format('MMMM')}
                                </option>
                            ))}
                        </Input>
                    </FormGroup>
                </Col>
                <Col md={3}>
                    <FormGroup>
                        <Label>Year</Label>
                        <Input
                            type="select"
                            value={year}
                            onChange={handleYearChange}
                        >
                            {Array.from({ length: 10 }, (_, i) => dayjs().year() - 5 + i).map((y) => (
                                <option key={y} value={y}>
                                    {y}
                                </option>
                            ))}
                        </Input>
                    </FormGroup>
                </Col>
                <Col md={6} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                    <Button color="primary" size="sm" onClick={openCalculateModal}>
                        Calculate Salary
                    </Button>
                    <Button color="success" size="sm" onClick={generateSalaryReport} style={{ marginLeft: '8px' }}>
                        Generate Salary Report
                    </Button>
                </Col>
            </Row>

            <Row>
                <Col>
                    <Card>
                        <CardHeader>
                            <h3>Salaries</h3>
                        </CardHeader>
                        <CardBody>
                            {loading ? (
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <Spinner color="primary" />
                                </div>
                            ) : (
                                <>
                                    {totalCount === 0 ? (
                                        <p>No records found.</p>
                                    ) : (
                                        <Table>
                                            <thead>
                                                <tr>
                                                    <th>Staff Name</th>
                                                    <th>Month</th>
                                                    <th>Year</th>
                                                    <th>Final Salary</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {salaries.map((salary) => (
                                                    <tr key={salary._id}>
                                                        <td>{salary.teacherId?.name}</td>
                                                        <td>{dayjs().month((salary.month || 1) - 1).format('MMMM')}</td>
                                                        <td>{salary.year}</td>
                                                        <td>{salary.finalSalary?.toFixed(2)}</td>
                                                        <td>
                                                            <ButtonGroup size="sm">
                                                                <Button color="info" size="sm" onClick={() => handleView(salary)}>
                                                                    View
                                                                </Button>
                                                                <Button color="primary" size="sm" onClick={() => downloadIndividualSalarySlip(salary)}>
                                                                    Download Slip
                                                                </Button>
                                                                <Button color="secondary" size="sm" onClick={() => printSalaryDetails(salary)}>
                                                                    Print Details
                                                                </Button>
                                                            </ButtonGroup>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    )}
                                </>
                            )}
                            {renderPagination()}
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            {/* View Modal */}
            <Modal isOpen={viewModalOpen} toggle={handleCloseViewModal} size="lg">
                <ModalHeader toggle={handleCloseViewModal}>Salary Details</ModalHeader>
                <ModalBody>
                    {selectedSalary && (
                        <div>
                            <p><strong>Staff Name:</strong> {selectedSalary.teacherId?.name}</p>
                            <p><strong>Month:</strong> {dayjs().month((selectedSalary.month || 1) - 1).format('MMMM')}</p>
                            <p><strong>Year:</strong> {selectedSalary.year}</p>
                            <p><strong>Final Salary:</strong> {selectedSalary.finalSalary?.toFixed(2)}</p>

                            <p><strong>Basic Salary:</strong> {selectedSalary.basicSalary?.toFixed(2)}</p>
                            <p><strong>Total Allowances:</strong> {selectedSalary.totalAllowances?.toFixed(2)}</p>
                            <p><strong>Total Deductions:</strong> {selectedSalary.totalDeductions?.toFixed(2)}</p>
                            <p><strong>Total Bonuses:</strong> {selectedSalary.totalBonuses?.toFixed(2)}</p>

                            {/* Allowances */}
                            {selectedSalary.allowances && selectedSalary.allowances.length > 0 && (
                                <>
                                    <p><strong>Allowances:</strong></p>
                                    <ul>
                                        {selectedSalary.allowances.map(allowance => (
                                            <li key={allowance._id}>
                                                {allowance.name}: {allowance.value?.toFixed(2)}
                                            </li>
                                        ))}
                                    </ul>
                                </>
                            )}

                            {/* Deductions */}
                            {selectedSalary.deductions && selectedSalary.deductions.length > 0 && (
                                <>
                                    <p><strong>Deductions:</strong></p>
                                    <ul>
                                        {selectedSalary.deductions.map(deduction => (
                                            <li key={deduction._id}>
                                                {deduction.name}: {deduction.value?.toFixed(2)}
                                            </li>
                                        ))}
                                    </ul>
                                </>
                            )}

                            {/* Bonuses */}
                            {selectedSalary.bonuses && selectedSalary.bonuses.length > 0 && (
                                <>
                                    <p><strong>Bonuses:</strong></p>
                                    <ul>
                                        {selectedSalary.bonuses.map(bonus => (
                                            <li key={bonus._id}>
                                                {bonus.name}: {bonus.value?.toFixed(2)}
                                            </li>
                                        ))}
                                    </ul>
                                </>
                            )}

                            {/* Total Overtime */}
                            <p>
                                <strong>Total Overtime:</strong>
                            </p>
                            <p>
                                <strong>Hours:</strong> {selectedSalary.totalOvertime?.hours?.toFixed(2) || '0.00'}
                            </p>
                            <p>
                                <strong>Price Per Hour (if any):</strong> {selectedSalary.totalOvertime?.pricePerHour?.toFixed(2) || '0.00'}
                            </p>
                            <p>
                                <strong>Total Overtime Amount:</strong> {selectedSalary.totalOvertime?.totalOvertimeAmount?.toFixed(2) || '0.00'}
                            </p>

                            {/* Attendance Details */}
                            <p>
                                <strong>Attendance Details:</strong>
                            </p>
                            {selectedSalary.attendanceDetails && (
                                <>
                                    {/* Full Days */}
                                    {selectedSalary.attendanceDetails.fullDays && (
                                        <>
                                            <p>
                                                <strong>Full Days:</strong>
                                            </p>
                                            <p>
                                                <strong>Count:</strong> {selectedSalary.attendanceDetails.fullDays.count?.toFixed(2)}
                                            </p>
                                            <p>
                                                <strong>Salary Per Day (if any):</strong> {selectedSalary.attendanceDetails.fullDays.salaryPerDay?.toFixed(2)}
                                            </p>
                                            <p>
                                                <strong>Total Full Day Salary:</strong> {selectedSalary.attendanceDetails.fullDays.totalFullDaySalary?.toFixed(2)}
                                            </p>
                                        </>
                                    )}

                                    {/* Half Days */}
                                    {selectedSalary.attendanceDetails.halfDays && (
                                        <>
                                            <p>
                                                <strong>Half Days:</strong>
                                            </p>
                                            <p>
                                                <strong>Count:</strong> {selectedSalary.attendanceDetails.halfDays.count?.toFixed(2)}
                                            </p>
                                            <p>
                                                <strong>Salary Per Half Day (if any):</strong> {selectedSalary.attendanceDetails.halfDays.salaryPerHalfDay?.toFixed(2)}
                                            </p>
                                            <p>
                                                <strong>Total Half Day Salary:</strong> {selectedSalary.attendanceDetails.halfDays.totalHalfDaySalary?.toFixed(2)}
                                            </p>
                                        </>
                                    )}

                                    {/* Absences */}
                                    {selectedSalary.attendanceDetails.absences && (
                                        <>
                                            <p>
                                                <strong>Absences:</strong>
                                            </p>
                                            <p>
                                                <strong>Count:</strong> {selectedSalary.attendanceDetails.absences.count?.toFixed(2)}
                                            </p>
                                            <p>
                                                <strong>Deduction Per Absence (if any):</strong> {selectedSalary.attendanceDetails.absences.deductionPerAbsence?.toFixed(2)}
                                            </p>
                                            <p>
                                                <strong>Total Absence Deduction:</strong> {selectedSalary.attendanceDetails.absences.totalAbsenceDeduction?.toFixed(2)}
                                            </p>
                                        </>
                                    )}

                                    {/* Total Days (For Part Time) */}
                                    {selectedSalary.attendanceDetails.totalDays !== undefined && (
                                        <p>
                                            <strong>Total Days:</strong> {selectedSalary.attendanceDetails.totalDays?.toFixed(2)}
                                        </p>
                                    )}

                                    {/* Total Hours (For Visit) */}
                                    {selectedSalary.attendanceDetails.totalHours !== undefined && (
                                        <p>
                                            <strong>Total Hours:</strong> {selectedSalary.attendanceDetails.totalHours?.toFixed(2)}
                                        </p>
                                    )}
                                </>
                            )}
                        </div>
                    )}
                </ModalBody>
            </Modal>

            {/* Calculate Salary Modal */}
            <Modal isOpen={calculateModalOpen} toggle={closeCalculateModal}>
                <ModalHeader toggle={closeCalculateModal}>Calculate Salary</ModalHeader>
                <ModalBody>
                    <FormGroup>
                        <Label>Month</Label>
                        <Input
                            type="select"
                            value={calculateMonth}
                            onChange={handleCalculateMonthChange}
                        >
                            {Array.from({ length: 12 }, (_, i) => i + 1).map((m) => (
                                <option key={m} value={m}>
                                    {dayjs().month(m - 1).format('MMMM')}
                                </option>
                            ))}
                        </Input>
                    </FormGroup>
                    <FormGroup>
                        <Label>Year</Label>
                        <Input
                            type="select"
                            value={calculateYear}
                            onChange={handleCalculateYearChange}
                        >
                            {Array.from({ length: 10 }, (_, i) => dayjs().year() - 5 + i).map((y) => (
                                <option key={y} value={y}>
                                    {y}
                                </option>
                            ))}
                        </Input>
                    </FormGroup>
                    <Button color="primary" onClick={calculateSalary} disabled={loading}>
                        {loading ? <Spinner size="sm" /> : 'Calculate'}
                    </Button>
                </ModalBody>
            </Modal>
        </Container>
    );
}

export default SalaryManagement;
